import {autoserializeAs} from 'cerialize';
import {ProductModel} from './product.model';
import {AssetModel} from './asset.model';

export class AssetProductModel {
    @autoserializeAs(AssetModel) public asset: AssetModel;
    @autoserializeAs(ProductModel) public products: ProductModel[];
    public primary = false;
}
